import { computed, Directive, ElementRef, inject, input } from '@angular/core';
import { ButtonVariantProps, buttonVariants } from './button.variants';

@Directive({
  selector: 'button[libButton], a[libButton]',
  host: {
    '[class]': 'classes()',
    '[attr.type]': 'hostType()',
  },
})
export class ButtonDirective {
  public readonly variant = input<ButtonVariantProps['variant']>('primary');
  public readonly size = input<ButtonVariantProps['size']>('sm');
  public readonly class = input('');
  public readonly type = input<'button' | 'submit' | 'reset'>('button');

  readonly #isAnchor =
    inject<ElementRef<HTMLElement>>(ElementRef).nativeElement.tagName === 'A';

  protected readonly classes = computed(() => {
    const variant = this.variant();
    const requestedSize = this.size();
    const size =
      (variant === 'chip' || variant === 'chip-danger') && requestedSize === 'sm' ? 'chip' : requestedSize;

    return [
      buttonVariants({
        variant,
        size,
      }),
      this.class(),
    ]
      .filter(Boolean)
      .join(' ');
  });

  /** The type attribute only makes sense on real buttons, not anchors. */
  protected readonly hostType = computed(() => (this.#isAnchor ? null : this.type()));
}
